import Auth from '../../modules/Authentication'
import {apiUrl} from '../../variables'
import {handleErrors, handleResponse} from '../../modules/Utils'

const headers = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
}
const auth = new Auth()

export const PaymentPlansApi = {
  list: id => {
    headers['authorization'] = `Bearer ${auth.getAccessToken()}`
    return fetch(`${apiUrl}paymentPlans/${id}`, {headers})
      .then(handleErrors)
      .then(handleResponse)
  },
  create: data => {
    headers['authorization'] = `Bearer ${auth.getAccessToken()}`
    return fetch(`${apiUrl}paymentPlans/`, {
      headers: headers,
      method: 'POST',
      body: JSON.stringify(data),
    })
      .then(handleErrors)
      .then(handleResponse)
  },
  update: data => {
    headers['authorization'] = `Bearer ${auth.getAccessToken()}`
    return fetch(`${apiUrl}paymentPlans/`, {
      headers: headers,
      method: 'PATCH',
      body: JSON.stringify(data),
    })
      .then(handleErrors)
      .then(handleResponse)
  },
  remove: data => {
    headers['authorization'] = `Bearer ${auth.getAccessToken()}`
    return fetch(`${apiUrl}paymentPlans/`, {
      headers: headers,
      method: 'DELETE',
      body: JSON.stringify(data),
    }).then(handleErrors)
  },
}
